import { useTranslate } from '@bynder/localization';
import { SpacingWidgetOptions } from '../../../../../constants/widgets';
import { useSpacerWidgetMutations } from '../../../../../mutations/widgets/spacer';
import { List, Tabs } from '@bynder/design-system';
import { IconDisabled, IconDottedLine, IconSolidLine } from '@bynder/icons';

const SpacerWidgetDividerTabs: React.FC<{
  divider: SpacingWidgetOptions;
  updateSpacerWidget: ReturnType<
    typeof useSpacerWidgetMutations
  >['updateSpacerWidget'];
}> = ({ divider, updateSpacerWidget }) => {
  const { translate } = useTranslate();
  const isNoneSelected = divider === SpacingWidgetOptions.None || !divider;
  const isDashedSelected = divider === SpacingWidgetOptions.Dashed;
  const isSolidSelected = divider === SpacingWidgetOptions.Solid;

  const handleChangeDivider = (widgetDivider: SpacingWidgetOptions) => {
    updateSpacerWidget.mutate({ widgetDivider });
  };
  return (
    <List.Group title={translate('WIDGETS_INSPECTOR.LINE_TITLE')}>
      <Tabs variant="clean">
        <Tabs.Tab
          data-testid="spacerWidgetDividerNone"
          label="None"
          isLabelHidden
          isActive={isNoneSelected}
          onClick={() => handleChangeDivider(SpacingWidgetOptions.None)}
          icon={<IconDisabled />}
        />
        <Tabs.Tab
          data-testid="spacerWidgetDividerSolid"
          label="Solid"
          isLabelHidden
          isActive={isSolidSelected}
          onClick={() => handleChangeDivider(SpacingWidgetOptions.Solid)}
          icon={<IconSolidLine />}
        />
        <Tabs.Tab
          data-testid="spacerWidgetDividerDashed"
          label="Dashed"
          isLabelHidden
          isActive={isDashedSelected}
          onClick={() => handleChangeDivider(SpacingWidgetOptions.Dashed)}
          icon={<IconDottedLine />}
        />
      </Tabs>
    </List.Group>
  );
};

export default SpacerWidgetDividerTabs;
